import { render, staticRenderFns } from "./ActivityFormContractHeader.vue?vue&type=template&id=a152bff2&scoped=true&"
import script from "./ActivityFormContractHeader.vue?vue&type=script&lang=js&"
export * from "./ActivityFormContractHeader.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFormContractHeader.vue?vue&type=style&index=0&id=a152bff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152bff2",
  null
  
)

export default component.exports